import { onClosePage } from "@/utils/page_utils";
import { platform } from "@/utils/platform";
import { getRatio } from "@/utils/pxtorem";
import useNavigation from "@/utils/useNavigate";
import React from "react";
import styles from "./index.module.less";


// 左上角回退按钮，仅app用
const BackView: React.FC<{
  statusBarHeight?: number;
  imgSrc?: string;
}> = ({ statusBarHeight = 50, imgSrc = "https://akim-oss.aikucun.com/11d024154013c0ca47dfaeca33ecdeb6a5b9fcb6_1741862236773_33.png" }) => {
  const { navigateBack } = useNavigation();

  const goBack = () => {
    if (platform.isApp) {
      onClosePage();
    } else {
      navigateBack();
    }
  };

  console.log("getRatio()", getRatio());

  return (
    <div className={styles.BackView} onClick={() => goBack()} style={{ top: (statusBarHeight + 12) * getRatio() }}>
      <img
        className={`${styles.ic_back} `}
        src={imgSrc}
      />
    </div>
  );
};

export default BackView;
